export default __webpack_public_path__ + "159a74a71188c0deffd902369a39c4f0.glb";